(function () {
  function pad(value) {
    return String(value).padStart(2, '0');
  }

  function toInt(value) {
    var parsed = parseInt(value, 10);
    return Number.isNaN(parsed) ? 0 : parsed;
  }

  function getStorageKey(timerEl) {
    var timerKey = timerEl.getAttribute('data-timer-key');
    if (!timerKey) {
      return null;
    }

    return 'landing-offer-card-timer-' + timerKey;
  }

  function getStoredTargetTime(timerEl) {
    var storageKey = getStorageKey(timerEl);
    if (!storageKey) {
      return null;
    }

    try {
      var storedValue = window.localStorage.getItem(storageKey);
      if (!storedValue) {
        return null;
      }

      var parsedValue = parseInt(storedValue, 10);
      return Number.isNaN(parsedValue) ? null : parsedValue;
    } catch (error) {
      return null;
    }
  }

  function setStoredTargetTime(timerEl, targetTime) {
    var storageKey = getStorageKey(timerEl);
    if (!storageKey) {
      return;
    }

    try {
      window.localStorage.setItem(storageKey, String(targetTime));
    } catch (error) {
      // Ignore storage errors (private mode, quota, etc.).
    }
  }

  function renderTimer(timerEl) {
    var timerMode = timerEl.getAttribute('data-timer-mode') || 'end_date';
    var targetTime = 0;

    if (timerMode === 'duration') {
      var durationHours = toInt(timerEl.getAttribute('data-duration-hours'));
      var durationMinutes = toInt(timerEl.getAttribute('data-duration-minutes'));
      var durationSeconds = toInt(timerEl.getAttribute('data-duration-seconds'));
      var durationMs = Math.max((durationHours * 3600 + durationMinutes * 60 + durationSeconds) * 1000, 0);

      if (durationMs <= 0) {
        return;
      }

      var storedTargetTime = getStoredTargetTime(timerEl);
      if (storedTargetTime !== null) {
        targetTime = storedTargetTime;
      } else {
        targetTime = Date.now() + durationMs;
        setStoredTargetTime(timerEl, targetTime);
      }
    } else {
      var endDateRaw = timerEl.getAttribute('data-end-date');
      if (!endDateRaw) {
        return;
      }

      targetTime = new Date(endDateRaw).getTime();
      if (Number.isNaN(targetTime)) {
        return;
      }
    }

    var hoursEl = timerEl.querySelector('[data-hours]');
    var minutesEl = timerEl.querySelector('[data-minutes]');
    var secondsEl = timerEl.querySelector('[data-seconds]');

    if (!hoursEl || !minutesEl || !secondsEl) {
      return;
    }

    function tick() {
      var now = Date.now();
      var diff = Math.max(targetTime - now, 0);

      var hours = Math.floor(diff / 3600000);
      var minutes = Math.floor((diff % 3600000) / 60000);
      var seconds = Math.floor((diff % 60000) / 1000);

      hoursEl.textContent = pad(hours);
      minutesEl.textContent = pad(minutes);
      secondsEl.textContent = pad(seconds);

      if (diff <= 0) {
        clearInterval(intervalId);
      }
    }

    tick();
    var intervalId = window.setInterval(tick, 1000);
  }

  function init() {
    var timers = document.querySelectorAll('.landing-offer-card__countdown');
    timers.forEach(renderTimer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
